export default __webpack_public_path__ + "static/media/moderate-graph.81824169.svg";